import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import ModalContents from "./components/ModalContents/ModalContents";
import ModalFooter from "./components/ModalFooter/ModalFooter";
import ModalHeader from "./components/ModalHeader/ModalHeader";
import "./RegistrationFormModal.scss";

type RegistrationFormModalProps = {
  isRegistrationModalOpen: boolean;
};

const RegistrationFormModal = ({
  isRegistrationModalOpen,
}: RegistrationFormModalProps): JSX.Element => {
  if (!isRegistrationModalOpen) return null;

  return (
    <div className="registration-form-modal__overlay">
      <div className="registration-form-modal__placeholder">
        <div className="registration-form-modal">
          <ModalHeader />
          <ModalContents />
          <ModalFooter />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  isRegistrationModalOpen: state.registrationFormModel.isRegistrationModalOpen,
});

export default connect(
  mapStateToProps,
  null
)(injectIntl(RegistrationFormModal));
